<template>
  <Modal v-model="visible" :title="title" width="560" :mask-closable="false" transfer>
    <Form :label-width="110" :show-message="false" label-position="right">
      <Form-item label="外教">
        <span>{{ tchText }}</span>
        <span v-if="row && row.country" class="muted">· {{ row.country }}</span>
      </Form-item>
      <Form-item label="原合同期">
        <span>{{ (row && row.crtBeginDate) || '—' }} ~ {{ (row && row.crtEndDate) || '—' }}</span>
        <span v-if="row && row.daysLeft != null" class="muted">（{{ daysLabel }}）</span>
      </Form-item>
      <Form-item label="新合同起始日" required>
        <Date-picker type="date" :value="form.crtBeginDate" :clearable="false" transfer
                     style="width: 180px;" @on-change="onBeginChange"></Date-picker>
      </Form-item>
      <Form-item label="新合同到期日" required>
        <Date-picker type="date" :value="form.crtEndDate" :clearable="false" transfer
                     style="width: 180px;" @on-change="form.crtEndDate = $event"></Date-picker>
      </Form-item>
      <Form-item label="备注">
        <Input v-model="form.note" type="textarea" :rows="3" :maxlength="1000"
               placeholder="续签年限、薪资调整、签署状态等"></Input>
      </Form-item>
    </Form>
    <div slot="footer">
      <Button @click="visible = false">取消</Button>
      <Button type="primary" :loading="saving" @click="submit">确认续签</Button>
    </div>
  </Modal>
</template>
<script>
import { API_PREFIX, tchLabel } from '../constants'
export default {
  name: 'ContractRenewModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      visible: false,
      saving: false,
      form: {
        crtBeginDate: '',
        crtEndDate: '',
        note: ''
      }
    }
  },
  computed: {
    tchText () {
      let r = this.row
      if (!r) {
        return '—'
      }
      return tchLabel(r) + '（ID ' + r.tchId + '）'
    },
    title () {
      return '登记续签 · ' + (tchLabel(this.row) || '')
    },
    daysLabel () {
      let d = this.row && this.row.daysLeft
      if (d == null) {
        return ''
      }
      return d < 0 ? '已超期 ' + Math.abs(d) + ' 天' : '剩 ' + d + ' 天'
    }
  },
  watch: {
    value (val) {
      this.visible = val
      if (val) {
        this.resetForm()
      }
    },
    visible (val) {
      if (val === false) {
        this.$emit('on-close')
      }
    }
  },
  methods: {
    resetForm () {
      let end = this.row && this.row.crtEndDate
      let begin = end ? this.$moment(end, 'YYYY-MM-DD').add(1, 'days') : this.$moment()
      this.form = {
        crtBeginDate: begin.format('YYYY-MM-DD'),
        crtEndDate: this.defaultEnd(begin.format('YYYY-MM-DD')),
        note: ''
      }
    },
    defaultEnd (begin) {
      return this.$moment(begin, 'YYYY-MM-DD').add(12, 'months').format('YYYY-MM-DD')
    },
    onBeginChange (val) {
      this.form.crtBeginDate = val
      if (val) {
        this.form.crtEndDate = this.defaultEnd(val)
      }
    },
    submit () {
      let self = this
      let f = self.form
      if (!self.row || !self.row.tchId) {
        return
      }
      if (!f.crtBeginDate || !f.crtEndDate) {
        self.$Message.warning('请填写完整的新合同起止日期')
        return
      }
      if (f.crtBeginDate > f.crtEndDate) {
        self.$Message.warning('到期日不能早于起始日')
        return
      }
      self.saving = true
      self.$http.post(API_PREFIX + '/contract/renew', {
        tchId: self.row.tchId,
        crtBeginDate: f.crtBeginDate,
        crtEndDate: f.crtEndDate,
        note: f.note
      }).then(function (res) {
        if (res && res.status === 'ok') {
          self.$Message.success('续签已登记，提醒解除')
          self.visible = false
          self.$root.$emit('hr-badges-refresh')
          self.$emit('on-success')
        }
      }).finally(function () {
        self.saving = false
      })
    }
  }
}
</script>
<style scoped lang="less">
.muted {
  margin-left: 6px;
  color: #8B93A7;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// ContractRenewModal.vue?1b99271e